/** Strip `?version=` suffix from DM ids used in item paths. */
export function normalizeDataManagementItemId(itemId: string): string {
  const q = itemId.indexOf("?");
  return q >= 0 ? itemId.slice(0, q) : itemId;
}

const LINEAGE_PREFIX = "urn:adsk.wipprod:dm.lineage:";
const FILE_VF_PREFIX = "urn:adsk.wipprod:fs.file:vf.";

/** ACC folder listings use lineage ids; version/download APIs use fs.file ids. */
export function accFileItemIdFromLineage(itemId: string): string | undefined {
  const base = normalizeDataManagementItemId(itemId);
  if (!base.startsWith(LINEAGE_PREFIX)) return undefined;
  return `${FILE_VF_PREFIX}${base.slice(LINEAGE_PREFIX.length)}`;
}

function pushUnique(out: string[], id: string | undefined): void {
  if (!id) return;
  const n = normalizeDataManagementItemId(id);
  if (n.length > 0 && !out.includes(n)) out.push(n);
}

/**
 * GET `/items/{id}/versions` — lineage id first (ACC list API), then fs.file.
 */
export function accVersionsListPathCandidates(itemId: string): string[] {
  const out: string[] = [];
  pushUnique(out, itemId);
  pushUnique(out, accFileItemIdFromLineage(itemId));
  return out;
}

/**
 * GET `/items/{id}/versions/{versionId}` — fs.file item segment first (lineage 404s).
 */
export function accVersionDetailPathCandidates(
  itemId: string,
  versionId: string
): string[] {
  const out: string[] = [];
  pushUnique(out, accFileItemIdFromLineage(itemId));
  pushUnique(out, versionId);
  pushUnique(out, itemId);
  return out;
}

/** GET `/items/{id}` metadata (parent folder, delete) — lineage first. */
export function accItemMetadataPathCandidates(itemId: string): string[] {
  const out: string[] = [];
  pushUnique(out, itemId);
  pushUnique(out, accFileItemIdFromLineage(itemId));
  return out;
}

/** ACC soft-delete requires `urn:adsk.wipprod:dm.lineage:…` on the version payload. */
export function accLineageItemIdForDelete(itemId: string): string {
  const base = normalizeDataManagementItemId(itemId);
  if (base.startsWith(LINEAGE_PREFIX)) return base;
  if (base.startsWith(FILE_VF_PREFIX)) {
    return `${LINEAGE_PREFIX}${base.slice(FILE_VF_PREFIX.length)}`;
  }
  return base;
}
